import {HarKV} from './harKV';
import {HttpRequest} from '@angular/common/http';

export class HarRequest {
    httpVersion: string;
    method: string;
    url: string;
    headers: HarKV[];
    cookies: HarKV[];
    queryString: HarKV[];

    constructor(request: HttpRequest<any>) {
      this.httpVersion = 'http/2';
      this.method = request.method;
      this.url = request.url;

      // Headers
      this.headers = [];
      for (const header of request.headers.keys()) {
        const newHeader = new HarKV(header, request.headers.get(header).toString());
        this.headers.push(newHeader);
      }

      // Cookies
      this.cookies = [];

      // Query String
      this.queryString = [];
      for (const param of request.params.keys()) {
        const newQueryParam = new HarKV(param, request.params.get(param).toString());
        this.queryString.push(newQueryParam);
      }
    }
}
